
import React, { Fragment } from 'react';
import { Column, Row } from "simple-flexbox";


const Component0 = () => {
    return(
        <Fragment>
            <h2>Nos objectifs<br/><b>2030</b></h2>
        </Fragment>
    );
}
export default Component0;